import React, { useEffect, useState } from "react";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { Checkbox, FormControlLabel } from "@mui/material";

// const data = [
//   {
//     name: "2025-06-02",
//     "FEDL01 Index": 40.23,
//     "H15T10Y Index": 24,
//     "SOFRRATE Index": 50,
//   },
//   {
//     name: "2025-06-01",
//     "FEDL01 Index": 30,
//     "H15T10Y Index": null,
//     "SOFRRATE Index": 60,
//   },
//   {
//     name: "2025-05-28",
//     "FEDL01 Index": 23,
//     "H15T10Y Index": 38,
//     "SOFRRATE Index": 80,
//   },
// ];

const LineChartWithLegendFilter = ({ filteredData } = {}) => {
  // const [seriesVisibility, setSeriesVisibility] = useState({
  //   "FEDL01 Index": { visible: true, color: "#8884d8" },
  //   "H15T10Y Index": { visible: true, color: "#82ca9d" },
  //   "SOFRRATE Index": { visible: true, color: "#ffc658" },
  // });
  const [data, setData] = useState([]);
  const [seriesVisibility, setSeriesVisibility] = useState({});

  useEffect(() => {
    const initialVisibility = filteredData.reduce((acc, { ticker, color }) => {
      acc[ticker] = { visible: true, color };
      return acc;
    }, {});

    setSeriesVisibility(initialVisibility);
  }, [filteredData]);

  useEffect(() => {
    const allDateStrings = [
      ...new Set(
        filteredData.flatMap(({ reports }) =>
          reports.map(({ reportDate }) => reportDate.split("T")[0])
        )
      ),
    ];

    const parseDate = (dateString) => {
      const [month, day, year] = dateString.split("-").map(Number);
      return new Date(year, month - 1, day);
    };

    const sortedAllDates = allDateStrings.sort((a, b) => {
      const dateA = parseDate(a);
      const dateB = parseDate(b);
      return dateA.getTime() - dateB.getTime();
    });

    const formattedData = sortedAllDates.map((date) => {
      const row = { name: date };

      filteredData.forEach(({ ticker, reports }) => {
        const report = reports.find((r) => r.reportDate.split("T")[0] === date);
        row[ticker] = report ? report.numericValue : null;
      });

      return row;
    });

    setData(formattedData);
  }, [filteredData]);

  const handleLegendClick = (series) => {
    const updatedSeries = {
      ...seriesVisibility[series],
      visible: !seriesVisibility[series].visible,
    };
    setSeriesVisibility({
      ...seriesVisibility,
      [series]: updatedSeries,
    });
  };

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <LineChart
        width={Math.max(800, window.innerWidth * 0.9)}
        height={300}
        data={data}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        {Object.keys(seriesVisibility).map((key) => {
          if (seriesVisibility[key].visible) {
            return (
              <Line
                key={key}
                type="monotone"
                dataKey={key}
                stroke={seriesVisibility[key].color}
                connectNulls
              />
            );
          }
          return null;
        })}
      </LineChart>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        {Object.keys(seriesVisibility).map((key) => (
          <FormControlLabel
            key={key}
            control={
              <Checkbox
                checked={seriesVisibility[key].visible}
                onChange={() => handleLegendClick(key)}
                name={key}
                style={{
                  color: data.find((d) => d[key] !== undefined)
                    ? seriesVisibility[key].color
                    : "#000",
                }}
              />
            }
            label={
              <span style={{ display: "flex", alignItems: "center" }}>
                <svg
                  width="30"
                  height="12"
                  style={{
                    marginRight: "5px",
                  }}
                >
                  <line
                    x1="0"
                    y1="6"
                    x2="10"
                    y2="6"
                    stroke={seriesVisibility[key].color}
                    strokeWidth="3"
                  />
                  <circle
                    cx="15"
                    cy="6"
                    r="4"
                    fill={seriesVisibility[key].color}
                  />
                  <line
                    x1="20"
                    y1="6"
                    x2="30"
                    y2="6"
                    stroke={seriesVisibility[key].color}
                    strokeWidth="3"
                  />
                </svg>
                <span style={{ color: seriesVisibility[key].color }}>
                  {key}
                </span>
              </span>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default LineChartWithLegendFilter;
